

































































































































import { Component, Vue } from "vue-property-decorator";
import { API } from "@/shared/api";
import { ssmHttpService } from "@/shared/services/http-service";
import { MessageService } from "@/shared/services/message-service";
import { citasHubService } from "@/shared/services/CitasHubService";

@Component({ name: "PublicAgendaWizardTest" })
export default class PublicAgendaWizardTest extends Vue {
  public step: number = 1;

  public centros: any[] = [];
  public servicios: any[] = [];
  public doctores: any[] = [];
  public daySlots: any[] = [];

  public selectedCentro: any = null;
  public selectedServicio: any = null;
  public selectedDoctor: any = null;
  public selectedDate: string = "";
  public selectedSlot: any = null;

  public confirming: boolean = false;
  public confirmResult: any = null;

  public contacto: any = {
    nombre: "",
    apellidos: "",
    telefono: "",
    email: "",
    motivo: "",
  };

  public mounted() {
    const today = new Date();
    this.selectedDate = `${today.getFullYear()}-${this.pad(today.getMonth() + 1)}-${this.pad(today.getDate())}`;
    this.loadCentros();
  }

  public async loadCentros() {
    try {
      this.centros = await ssmHttpService.get(`${API.publicAgenda}/centros`, null, false);
      if (!Array.isArray(this.centros)) this.centros = [];
    } catch (e) {
      this.centros = [];
      MessageService.alert("Error", "No se pudieron cargar centros", MessageService.TypeError);
    }
  }

  public async selectCentro(c: any) {
    this.selectedCentro = c;
    this.selectedServicio = null;
    this.selectedDoctor = null;
    this.selectedSlot = null;
    this.doctores = [];
    this.daySlots = [];
    await this.loadServicios();
    this.step = 2;
  }

  public async loadServicios() {
    if (!this.selectedCentro) return;
    try {
      const url = `${API.publicAgenda}/centros/${this.selectedCentro.id}/servicios`;
      const res = await ssmHttpService.get(url, null, false);
      this.servicios = Array.isArray(res) ? res : [];
    } catch (e) {
      this.servicios = [];
      MessageService.alert("Error", "No se pudieron cargar servicios", MessageService.TypeError);
    }
  }

  public async selectServicio(srv: any) {
    this.selectedServicio = srv;
    this.selectedDoctor = null;
    this.selectedSlot = null;
    await this.loadDoctores();
    this.step = 3;
  }

  public async loadDoctores() {
    if (!this.selectedCentro || !this.selectedServicio) return;
    try {
      const q = this.buildQuery({ codigoServicio: this.selectedServicio.codigo_elegido, waitSeconds: 25 });
      const url = `${API.publicAgenda}/centros/${this.selectedCentro.id}/doctores${q}`;
      const res = await ssmHttpService.get(url, null, false);
      const rows = res && Array.isArray(res.rows) ? res.rows : [];
      this.doctores = rows;
    } catch (e) {
      this.doctores = [];
      MessageService.alert("Error", "No se pudieron cargar doctores", MessageService.TypeError);
    }
  }

  public selectNoPreference() {
    this.selectedDoctor = null;
  }

  public selectDoctor(d: any) {
    this.selectedDoctor = d;
  }

  public async goToSlots() {
    this.step = 4;
    await this.loadSlotsForDate();
  }

  public async onDateChanged() {
    this.selectedSlot = null;
    await this.loadSlotsForDate();
  }

  public async loadSlotsForDate() {
    if (!this.selectedCentro || !this.selectedServicio || !this.selectedDate) return;

    const from = `${this.selectedDate}T00:00:00`;
    const to = `${this.selectedDate}T23:59:59`;

    const q = this.buildQuery({
      doctorId: this.selectedDoctor ? this.selectedDoctor.ID_Agenda : null,
      from,
      to,
      limit: 50,
      waitSeconds: 25,
    });

    try {
      const url = `${API.publicAgenda}/centros/${this.selectedCentro.id}/servicios/${encodeURIComponent(this.selectedServicio.codigo_elegido)}/huecos${q}`;
      const res = await ssmHttpService.get(url, null, false);
      const rows = res && Array.isArray(res.rows) ? res.rows : [];
      this.daySlots = rows.sort((a: any, b: any) => new Date(a.fecha_hora_inicio_local).getTime() - new Date(b.fecha_hora_inicio_local).getTime());
    } catch (e) {
      this.daySlots = [];
      MessageService.alert("Error", "No se pudieron cargar huecos", MessageService.TypeError);
    }
  }

  public selectSlot(slot: any) {
    this.selectedSlot = slot;
  }

  public async confirmarCita() {
    if (!this.selectedCentro || !this.selectedServicio || !this.selectedSlot) {
      MessageService.alert("Validacion", "Faltan datos de centro/servicio/hora", MessageService.TypeWarning);
      return;
    }
    if (!this.contacto.nombre || !this.contacto.telefono) {
      MessageService.alert("Validacion", "Nombre y telefono son obligatorios", MessageService.TypeWarning);
      return;
    }

    const start = new Date(this.selectedSlot.fecha_hora_inicio_local);
    const payload: any = {
      id_centro: this.selectedCentro.id,
      id_servicio: this.selectedServicio.id,
      codigo_servicio: this.selectedServicio.codigo_elegido,
      fecha_hora_inicio_solicitada: this.formatLocalDateTime(start),
      id_profesional_externo: this.selectedDoctor ? this.selectedDoctor.ID_Agenda : null,
      nombre_profesional: this.selectedDoctor ? this.selectedDoctor.NombreDoctorAgenda : "",
      motivo_paciente: this.contacto.motivo || "",
      nombre: this.contacto.nombre,
      apellidos: this.contacto.apellidos || "",
      telefono: this.contacto.telefono,
      email: this.contacto.email || "",
      fecha_nacimiento: null,
      documento: "",
    };

    this.confirming = true;
    try {
      const url = `${API.solicitudesWorkflow}/public/confirmar-final`;
      const res = await ssmHttpService.post(url, payload, false, false, false, citasHubService.getConnectionHeader());
      this.confirmResult = res;
      if (res && res.success) {
        MessageService.toast("Cita confirmada en workflow");
      }
    } catch (e) {
      this.confirmResult = this.extractHttpError(e);
      MessageService.alert("Error", "No se pudo confirmar la cita", MessageService.TypeError);
    } finally {
      this.confirming = false;
    }
  }

  public formatTime(dateText: string): string {
    const d = new Date(dateText);
    if (isNaN(d.getTime())) return "-";
    return `${this.pad(d.getHours())}:${this.pad(d.getMinutes())}`;
  }

  public getServiceIcon(srv: any): string {
    const code = ((srv && srv.codigo_elegido) || "").toUpperCase();
    if (code.indexOf("IMPL") >= 0) return "mdi-tooth-outline";
    if (code.indexOf("ENDO") >= 0) return "mdi-tooth";
    if (code.indexOf("PRO") >= 0) return "mdi-toothbrush";
    if (code.indexOf("HIG") >= 0) return "mdi-toothbrush-electric";
    return "mdi-medical-bag";
  }

  public pretty(v: any): string {
    try {
      return JSON.stringify(v, null, 2);
    } catch (e) {
      return String(v);
    }
  }

  private buildQuery(params: any): string {
    const parts: string[] = [];
    Object.keys(params).forEach((k) => {
      const v = params[k];
      if (v === null || v === undefined || v === "") return;
      parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
    });
    return parts.length > 0 ? `?${parts.join("&")}` : "";
  }

  private formatLocalDateTime(d: Date): string {
    return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}T${this.pad(d.getHours())}:${this.pad(d.getMinutes())}:${this.pad(d.getSeconds())}`;
  }

  private pad(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }

  private extractHttpError(error: any): any {
    const response = error && error.response ? error.response : null;
    return {
      success: false,
      status: response ? response.status : null,
      statusText: response ? response.statusText : "",
      message: error && error.message ? error.message : "Error desconocido",
      data: response ? response.data : null,
    };
  }
}
